
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequirefc28"];
var parcelRegister = parcelRequire.register;
parcelRegister("fEl82", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e92a63ff2991fa1c5e7c979e55a38ff9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b64afb2bd02b20f5$var$_react = $b64afb2bd02b20f5$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $b64afb2bd02b20f5$var$_iconNew = $b64afb2bd02b20f5$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $b64afb2bd02b20f5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Tag".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/tag
 * Usage guidance:
 * Single purpose - Reserved for tags in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b64afb2bd02b20f5$var$TagIcon = (props)=>/*#__PURE__*/ $b64afb2bd02b20f5$var$_react.default.createElement($b64afb2bd02b20f5$var$_iconNew.default, Object.assign({
        name: "TagIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M11 4a1 1 0 1 0 0 2 1 1 0 0 0 0-2"/><path fill="currentcolor" fill-rule="evenodd" d="M9.286 1a3.25 3.25 0 0 0-2.299.952L1.604 7.336a2 2 0 0 0 0 2.828l4.232 4.232a2 2 0 0 0 2.828 0l5.384-5.383A3.25 3.25 0 0 0 15 6.714V3a2 2 0 0 0-2-2zM8.048 3.013A1.75 1.75 0 0 1 9.286 2.5H13a.5.5 0 0 1 .5.5v3.714c0 .465-.184.91-.513 1.238l-5.383 5.384a.5.5 0 0 1-.708 0L2.664 9.104a.5.5 0 0 1 0-.708z" clip-rule="evenodd"/>`
    }, props));
$b64afb2bd02b20f5$var$TagIcon.displayName = 'TagIcon';
var $b64afb2bd02b20f5$var$_default = module.exports.default = $b64afb2bd02b20f5$var$TagIcon;

});


//# sourceMappingURL=tag.4ca5c5d4.js.map
